(function () {
  'use strict';

  if (!document.querySelector('.bf-vip')) return;
  if (window.__bfVipInit) return;
  window.__bfVipInit = true;

  // The only motion on this page: a subtle pulse on the second (CTA band)
  // submit button, started a few seconds in so it doesn't compete with page
  // load, plus a smooth scroll + focus into the hero email field for any
  // in-page link that points at it (e.g. the "How it works" CTA).
  var pulseBtn = document.querySelector('[data-bf-vip-pulse]');
  if (pulseBtn) {
    window.setTimeout(function () {
      pulseBtn.classList.add('is-pulsing');
    }, 2500);
  }

  // Typewriter effect on the email field's placeholder: types the real
  // placeholder text out, pauses, deletes it, repeats. Paused while the
  // field has focus so it doesn't fight with the person typing.
  document.querySelectorAll('[data-bf-vip-typewriter]').forEach(function (input) {
    var text = input.getAttribute('data-bf-vip-typewriter');
    if (!text) return;

    var i = 0;
    var deleting = false;
    var paused = false;
    var timer = null;

    function tick() {
      if (paused) return;

      if (!deleting) {
        i += 1;
        input.placeholder = text.slice(0, i);
        if (i >= text.length) {
          deleting = true;
          timer = window.setTimeout(tick, 1800);
          return;
        }
      } else {
        i -= 1;
        input.placeholder = text.slice(0, i);
        if (i <= 0) {
          deleting = false;
          timer = window.setTimeout(tick, 600);
          return;
        }
      }

      timer = window.setTimeout(tick, deleting ? 40 : 90);
    }

    input.addEventListener('focus', function () {
      paused = true;
    });

    input.addEventListener('blur', function () {
      if (!paused) return;
      paused = false;
      tick();
    });

    timer = window.setTimeout(tick, 600);
  });

  // Header CTA: this page's layout keeps the real site header (logo +
  // language selector only - see section-bf-vip.css), but the left-hand
  // slot that header already reserves (.header__desktop__bar__l) is
  // otherwise empty on this template. Drop a button in there, cloning the
  // hero's own CTA label so it always matches the live EN/FR copy instead of
  // hardcoding a second translation. Desktop only - the mobile header slot
  // keeps just the logo. Guarded so re-running this script (it loads once
  // per section on this page) doesn't insert it twice.
  var heroCta = document.querySelector('.bf-vip__hero .bf-vip__form-submit');
  var desktopSlot = document.querySelector('.header__desktop__bar__l');
  if (heroCta && desktopSlot && !document.querySelector('.bf-vip-header-cta')) {
    var btn = document.createElement('a');
    btn.href = '#BfVipHeroForm';
    btn.className = 'bf-vip-header-cta';
    btn.textContent = heroCta.textContent.trim();
    btn.setAttribute('data-bf-vip-scroll-cta', '');
    desktopSlot.appendChild(btn);
  }

  document.querySelectorAll('[data-bf-vip-scroll-cta]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var targetId = link.getAttribute('href').slice(1);
      var target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      var input = target.querySelector('input[type="email"]');
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 400);
      }
    });
  });
})();
